<template>
  <div>
  <header>
          <div class="headerOne">
                 <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)"> -->
              <span class="buss">关于我们</span>
          </div>
   </header>
   <div class="logo">
       <img src="../../assets/images/icon.png" alt="">
   </div>
   <div class="versions">y7.8.0.321</div>
    <div class="allSetting"> 
      <ul>
          <li>
              <span>功能介绍</span>
              <img src="../../assets/images/goOn.png" alt="">
           </li>
           <li >
              <span>服务条款</span>
              <img src="../../assets/images/goOn.png" alt="">
           </li>
           <li> 
              <span>反馈</span>
              <img src="../../assets/images/goOn.png" alt="">
           </li>
           <li @click="$router.push('/relation')">
              <span>联系方式 </span>
              <img src="../../assets/images/goOn.png" alt="">
           </li>
      </ul>
      
  </div>  
  </div>
    
</template>
<script>
import { DatetimePicker } from 'mint-ui';

    export default{
        data(){
            return{
                msg:"关于我们",
                   value: null,
        value2: null,
        value3: null,
        value4: null,
        value5: '04:32',
        visible: false,
        visible2: false,
        visible3: false,
        visible4: false,
        visible5: false
            }
        },
        methods:{
                  open(picker) {
                                 this.$refs[picker].open();
      },
            falseOne(){
               
            },
    
      handleChange(value) {
        Toast({
          message: '已选择 ' + value.toString(),
          position: 'bottom'
        });
      },
     
    
        }
    }
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
 header{
    height:1.6rem;
    width: 100%;
    border-bottom: 1px solid rgba(48, 1, 1, 0.2);
    position: relative;
}
 .headerOne{
     font-size: 0;  
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .headerOne .buss{
      display: inline-block;
      font-size: 0.55rem;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
  }
  .logo{
        background: white
  }
  .logo img{
      height:2.5rem;
        display:block;
        margin: 0 auto;
     margin-top:1.5rem;   
  }
  .versions{
      color: rgba(0, 0, 0, .5);
      font-size: 0.45rem;
      text-align: center;
      margin-top: 0.5rem;
      margin-bottom: 0.4rem
  }
   .allSetting ul li{
      font-size: 0.55rem;
      color: rgba(0,0,0,0.9);
      height: 1.7rem;
      line-height: 1.7rem;
      border-bottom: 1px solid rgba(0,0,0,0.2);
      padding-left: 0.35rem;
      clear: both;
  }
  /* .allSetting ul li span{
      vertical-align: middle;
   
  } */
   .allSetting ul li img{
       width: 0.35rem;
       height: auto;
       /* vertical-align: middle; */
       float: right;
       margin: 0.58rem 0.5rem 0 0;
   }
</style>



// WEBPACK FOOTER //
// src/components/change/aboutMy.vue